import React, { Component } from 'react';
import MultiElementProperties from './MultiElementPropertiesContainer';

class MultiElementEdit extends Component {
  render() {
    const {
      elementIds,
      elementType,
      callback,
    } = this.props;

    let closeButton = null;

    if (callback) {
      closeButton = <i onClick={callback} className="fa fa fa-times fa-2x" style={{ verticalAlign: 'middle' }}></i>
    }

    return (
      <div>
        <div style={{ float: 'right' }}>
          {closeButton}
        </div>
        <h1>Edit</h1>
        <MultiElementProperties
          elementIds={elementIds}
          elementType={elementType}
        />
      </div>
    );
  }

}

export default MultiElementEdit;



// WEBPACK FOOTER //
// ./src/components/RightColumn/MultiElementEdit/MultiElementEdit.js